import { Modal } from '@mantine/core'
import styled from 'styled-components'

export const ModalMantine = styled(Modal).withConfig({
  shouldForwardProp: (prop) => !['minHeight', 'useWhiteTheme'].includes(prop)
})`
  .mantine-Modal-body {
    padding: ${({ type }) => (type === 'alerta' ? '0px' : '0px !important')};
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    justify-content: flex-end;
    margin-top: 24px;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .mantine-Modal-close:hover {
    background-color: transparent;
  }

  .mantine-Modal-title {
    width: 100%;
  }

  .mantine-Modal-header {
    background-color: transparent;
    padding: 0;
  }

  .mantine-Modal-inner {
    z-index: 9999;
  }

  .mantine-Modal-content {
    background-color: ${({ theme, useWhiteTheme }) =>
      useWhiteTheme ? '#DFE3E2' : theme.cor23};
    padding: 24px;
    border-radius: 8px;
    min-height: ${({ minHeight }) => minHeight};
    max-height: 100% !important;
    width: ${({ width }) => width};
    overflow: hidden !important;
    transform-origin: center;
    display: flex;
    flex-direction: column;
  }

  .mantine-Modal-overlay {
    z-index: 9999;
    background-color: #00000080;
    animation: fade-in 0.3s ease;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const TituloWrapper = styled.div`
  ${({ type }) =>
    !['default', 'alerta'].includes(type) &&
    `
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 16px;
  `}
`

export const Titulo = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 16px;
`

export const TituloCenter = styled.div`
  text-align: center;
  align-items: center;
  gap: 16px;
`

export const TituloModal = styled.h1`
  font-family: RobotoRegular;
  margin: 0;
  font-weight: 100;
  font-size: 24px;
  color: ${({ theme, useWhiteTheme }) =>
    useWhiteTheme ? '#000000' : theme.cor9};
`

export const Elipse = styled.img`
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.cor11};
`

export const BotoesFiltroWrapper = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
`

export const LimparFiltroLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const BlankSlateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 40px;
  margin-bottom: 8px;
`

export const ModalContentWrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden !important;
  flex: 1;
  padding-bottom: 6px;
`

export const ModalActionsWrapper = styled.div`
  margin-top: 20px;
  padding-bottom: 6px;

  .mantine-Group-root {
    justify-content: flex-end;
    margin-top: 0;
  }
`